var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"demfor"}},[(['SDF'].includes(_vm.artefact.type))?_c('div',[_c('trend-mock',{key:_vm.artefact.type+'-1',attrs:{"artefact":_vm.artefact,"type":"category"}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }